import { create } from 'zustand';
import Alertas from '../alerts/AlertasGernericos';
import CryptoJS from 'crypto-js';
import apiClient from '../api/client';


export const useFotosProdutosStore = create((set, get) => ({

    carregando: false,
    logado: false,
    pagina_atual: 1,
    ultima_pagina: 0,
    hanking_de_grupos: [],
    total_de_grupos_ja_vendidos: 0,
    mostrar_grafico: true,
    deletingId: 0,
    produtos: [],
    cod_produto: 0,
    filtrosDeBusca: null,
    fecharModalDeUpload: false,


    setCodProduto: (valor) => set({ cod_produto: valor }),
    setCodProdutoDelete: (valor) => set({ deletingId: valor }),


    GetFotos: async () => {
        try {

            console.log("teste");
        } catch (err) {
            Alertas.ExibirAlertaErro(err.message || "Erro desconhecido durante o login.");
        }
    },

    searchFotos: async (filtros) => {

        set({ carregando: 'searching', pagina_atual: 1 });

        try {
            const response = await apiClient.get('/PesquisarProdutosComFotos', {
                params: {
                    nome: filtros.nm_produto,
                    status: filtros.status,
                    cod_produto: filtros.cod_produto,
                }
            });

            const { data, last_page, current_page } = response.data.produtos;

            if (!data || !response) {
                throw new Error("Não foi possível carregar os produtos.");
            }

            set({
                produtos: data,
                pagina_atual: current_page,
                ultima_pagina: last_page,
                carregando: 'idle'
            });

        } catch (error) {
            Alertas.ExibirAlertaErro(error.data?.message || "Não foi encotrado nenhum produto com esses dados.");
            set({ carregando: 'idle' });
        }
    },

    fetchFotos: async (page = 1) => {
        set({ carregando: 'fetching' });
        try {

            const resposta = await apiClient.get('/GetProdutosComFotos', {
                params: { page: page }
            });

            const { data, current_page, last_page } = resposta.data.produtos;

            if (!data || !resposta) {
                throw new Error("Não foi possível carregar os produtos.");
            }

            set({
                produtos: data,
                pagina_atual: current_page,
                ultima_pagina: last_page,
                carregando: 'idle'
            });

        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Erro ao buscar produtos.");
            set({ carregando: 'idle' });
        }
    },

    SalvarFoto: async (imagem) => {
        set({ carregando: 'save' });
        try {
            const { cod_produto } = get();
            const { Refresh } = get();

            const formData = new FormData();
            formData.append("foto", imagem.file);
            formData.append("quality", imagem.quality);
            formData.append("cod_produto", cod_produto);

            const response = await apiClient.post("/SalvarImagemDeProduto", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            const { erro, message, caminho_nova_foto } = response.data;

            if (erro) {
                throw new Error("Ocorreu um erro ao salvar sua imagem, tente novamente.");
            }
            await Refresh(caminho_nova_foto, cod_produto);


            set({ fecharModalDeUpload: true, carregando: 'idle' });
            Alertas.ExibirAlertaSucesso(message);

        } catch (error) {
            set({ fecharModalDeUpload: true, carregando: 'idle' });
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Erro ao salvar sua imagem.");
        }
    },

    Refresh: async (caminho_nova_foto, cod_produto) => {

        const { produtos } = get();

        produtos.map((prod) => {
            if (prod.cd_produto == cod_produto) {
                console.log("caminhoi antigo", prod.caminho_img)
                prod.caminho_img = caminho_nova_foto ?? ""
            }
        })

        set({ produtos: produtos })
    },

    DeletarFoto: async (cod_produto) => {
        set({ carregando: 'delete' });
        try {

            const { Refresh } = get();

            const response = await apiClient.delete('/RemoverFotoProduto', {
                data: { cod_produto }
            });


            const { erro, message } = response.data;

            if (!response) {
                throw new Error("Não foi possível carregar os produtos.");
            }

            if (erro) {
                throw new Error(message);
            }

            await Refresh("", cod_produto);

            Alertas.ExibirAlertaSucesso(message);
            set({ carregando: 'idle' });


        } catch (error) {
            set({ fecharModalDeUpload: true, carregando: 'idle' });
            Alertas.ExibirAlertaErro(error.message || "Erro ao remover sua imagem.");
        }
    },


}));



